import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      _createElementVNode("rect", {
        width: "16",
        height: "16",
        x: "4",
        y: "4",
        rx: "4"
      }),
      _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "3"
      }),
      _createElementVNode("path", { d: "M16.5 7.5v.001" })
    ], -1)
  ])))
}
export default { render: render }